<style scoped>
@screen md {
    .remind-message-container {
        margin: 0 2% 0 2%;
    }
}
</style>

<template>
    <div>
        <div class="my-8 flex justify-center" v-if="!order">
            <spinner />
        </div>
        <template v-else>
            <orderSuccessAnimation
                v-if="showOrderSuccessAnimation"
                @animationEnded="orderSuccessAnimationEnded"
            />
            <luckyDrawSalesOrderModal
                v-if="showLuckyDrawSalesOrderModal"
                @hide="showLuckyDrawSalesOrderModal = false"
                :eventId="luckyDrawSalesOrderModalParams.eventId"
                :tokenNum="luckyDrawSalesOrderModalParams.tokenNum"
            />
            <breadcrumb
                class="mt-4"
                :links="[
                    { msg: 'order.history', route: { name: 'orderHistory' } },
                    { text: order.saleOrdNum }
                ]"
            />

            <div
                v-if="showOrderSuccessAnimation"
                class="remind-message-container"
            >
                提提您：電子收據已發送至您的電郵地址。記得將
                <a href="mailto:cs@tryhala.com">cs@tryhala.com</a>
                加入為聯絡人呀！
            </div>

            <template v-if="false">
                <div
                    class="my-2 flex flex-col md:flex-row items-center"
                    :class="paymentMessageClass"
                >
                    <div class="mx-auto flex justify-center items-center">
                        <img :src="orderStatusImg" class="w-20 mr-2" />
                        <span class="text-4xl font-bold ">
                            {{ paymentMessage }}
                        </span>
                    </div>
                    <router-link
                        v-if="showKeeyBuyBtn"
                        class="ml-auto md:m-0 focus:outline-none text-blue pr-2 focus:text-darkGrayishBlue"
                        tag="button"
                        to="/"
                    >
                        {{ $t('order.continue.shopping') }}
                    </router-link>
                </div>

                <div class="my-2 flex justify-center items-center">
                    <loadingButton
                        v-if="showOrderCancelBtn"
                        class="btn bg-white justify-center py-2 font-black mt-1 px-16"
                        @click="cancelOrder"
                    >
                        {{ $t('order.cancel') }}
                    </loadingButton>
                    <loadingButton
                        v-if="showOrderSelectPaymentBtn"
                        class="btn bg-primary justify-center py-2 font-black mt-1 px-16"
                        @click="showPayment = true"
                    >
                        {{
                            $t(
                                !order.pymtSrvcPrvdId
                                    ? 'order.payment'
                                    : 'order.payment.retry'
                            )
                        }}
                    </loadingButton>
                </div>
            </template>

            <div v-if="showPayment && false">
                <div>
                    <h3 class="section-title mb-4">
                        {{ $t('order.payment.select.method') }}
                    </h3>
                    <div
                        class="flex items-center justify-between md:justify-end"
                    >
                        <paymentSelection @paymentSelected="paymentSelected" />
                    </div>
                </div>

                <div class="flex items-center justify-between md:justify-end">
                    <!-- :status="status" -->
                    <loadingButton
                        class="bg-primary px-4 md:px-16 justify-center py-2 font-black mt-1"
                        :class="{ 'opacity-50': !paymentOption }"
                        :disabled="!paymentOption"
                        @click="makePayment(paymentOption)"
                    >
                        {{
                            paymentOption &&
                            paymentOption.pymtSrvcPrvdId == 'CASH'
                                ? $t('common.confirm')
                                : $t('order.to.pay')
                        }}
                    </loadingButton>
                </div>
            </div>

            <div
                v-if="$config.testingConfig.showTestPayment()"
                class="border-4 border-primary p-2"
            >
                <div>
                    <h3 class="section-title mb-4">
                        {{
                            'Fake Payment (Testing)' +
                                $t('order.payment.select.method')
                        }}
                    </h3>
                    <div
                        class="flex items-center justify-between md:justify-end"
                    >
                        <paymentSelection @paymentSelected="paymentSelected" />
                    </div>
                </div>

                <div class="flex items-center justify-between md:justify-end">
                    <!-- :status="status" -->
                    <loadingButton
                        class="bg-primary px-4 md:px-16 justify-center py-2 font-black mt-1"
                        :class="{ 'opacity-50': !paymentOption }"
                        @click="makeFakePayment"
                    >
                        {{
                            paymentOption &&
                            paymentOption.pymtSrvcPrvdId == 'CASH'
                                ? $t('common.confirm')
                                : $t('order.to.pay')
                        }}
                    </loadingButton>
                </div>
            </div>

            <div
                v-if="$config.testingConfig.showTestPaymentEnquiry()"
                class="border-4 border-primary p-2"
            >
                <div>
                    <h3 class="section-title mb-4">
                        {{ 'testing' }}
                    </h3>
                </div>
                <div>
                    <loadingButton @click="enquiryPayment">
                        {{ 'Enquiry Payment' }}
                    </loadingButton>
                    <div>
                        {{ enquiryPaymentResult }}
                    </div>
                </div>
                <div>
                    <loadingButton @click="mpayTxnRpt">
                        {{ 'MPay Transaction Report' }}
                    </loadingButton>
                    <div>
                        {{ enquiryPaymentResult }}
                    </div>
                </div>
            </div>

            <div class="content-box-wrapper">
                <div class="flex flex-wrap items-center">
                    <div class="text-xl font-bold">
                        {{ $t('order.history') }}
                    </div>
                    <div
                        v-if="order.saleOrdStsCode === 'P'"
                        class="text-red text-sm ml-auto"
                    >
                        {{ $t('order.payment.processing.remind') }}
                    </div>
                </div>

                <order :order="order" class="mt-4" />
            </div>

            <router-link
                tag="button"
                to="/account/orderHistory"
                class="flex text-secondary mt-6"
            >
                <div class="icon"><chevronLeft /></div>
                <span class="font-bold hover:underline hover:text-blue-600">{{
                    $t('order.back.history')
                }}</span>
            </router-link>

            <modal
                type="alert"
                :showCancel="false"
                v-if="errors && errors.server"
                @confirm="errors.server = undefined"
            >
                {{ $t(errors.server) }}
            </modal>
        </template>
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import order from '@/components/order.vue';
import chevronLeft from '../../assets/svg/chevron_left.svg';
import img1s112 from '@/assets/img/1-112.png';
import img3s112 from '@/assets/img/3-112.png';
import img4s112 from '@/assets/img/4-112.png';
import img7s112 from '@/assets/img/7-112.png';
import modal from '@/components/modal.vue';
import loadingButton from '@/components/loadingButton.vue';
import paymentSelection from '@/components/paymentSelection.vue';
import { createForm } from '@/utils/formUtil';
import spinner from '@/components/spinner.vue';
// import { instance } from '@/utils/ajax';

export default {
    components: {
        breadcrumb,
        order,
        chevronLeft,
        modal,
        loadingButton,
        paymentSelection,
        spinner,
        orderSuccessAnimation: () =>
            import('../../components/orderSuccessAnimation.vue'),
        luckyDrawSalesOrderModal: () =>
            import('../../components/luckyDrawSalesOrderModal.vue')
    },
    data() {
        return {
            errors: {},
            paymentOption: undefined,
            showPayment: false,
            enquiryPaymentResult: undefined,
            showOrderSuccessAnimation: false,
            showLuckyDrawSalesOrderModal: false,
            luckyDrawSalesOrderModalParams: {
                eventId: undefined,
                tokenNum: undefined
            }
        };
    },
    created() {
        this.successImg = img1s112;
        this.progressImg = img4s112;
        this.failImg = img3s112;
        this.waitImg = img7s112;
    },
    computed: {
        order() {
            const orderNo = this.$route.params.orderNo;
            return this.$store.getters.orderByOrderNo(orderNo);
        },
        paymentMessageClass() {
            let order = this.order;
            return order.saleOrdStsCode == 'C' ? 'text-green' : 'text-red';
        },
        paymentMessage() {
            let order = this.order;
            if (order.saleOrdStsCode == 'X') {
                return this.$t('order.payment.cancel');
            } else if (
                order.pymtSrvcPrvdId == 'CASH' ||
                order.saleOrdStsCode == 'C'
            ) {
                return this.$t('order.payment.thank.you');
            } else if (!order.pymtSrvcPrvdId) {
                return this.$t('order.payment.notSelect');
            } else if (
                order.saleOrdStsCode == 'P' &&
                order.pymtStsCode == 'P'
            ) {
                return this.$t('order.payment.processing');
            } else if (
                order.saleOrdStsCode == 'P' &&
                order.pymtStsCode == 'F'
            ) {
                return this.$t('order.payment.fail');
            } else {
                return '';
            }
        },
        orderStatusImg() {
            let order = this.order;

            if (
                !order.pymtSrvcPrvdId ||
                (order.saleOrdStsCode == 'P' && order.pymtStsCode == 'P')
            ) {
                return this.waitImg;
            } else if (
                (order.saleOrdStsCode == 'P' && order.pymtStsCode == 'F') ||
                order.saleOrdStsCode == 'X'
            ) {
                return this.failImg;
            } else if (order.saleOrdStsCode == 'C') {
                return this.successImg;
            } else {
                return this.progressImg;
            }
        },
        showOrderCancelBtn() {
            let order = this.order;

            return order.saleOrdStsCode == 'P' && order.pymtStsCode != 'P';
        },
        showOrderSelectPaymentBtn() {
            let order = this.order;

            return (
                order.saleOrdStsCode == 'P' &&
                (!order.pymtSrvcPrvdId || order.pymtStsCode == 'F')
            );
        },
        showKeeyBuyBtn() {
            let order = this.order;
            return order.saleOrdStsCode == 'C';
        }
    },
    async mounted() {
        if (!this.order) {
            await this.$store.dispatch('loadOrderList');
        }

        if (!this.order) {
            this.$router.push({ name: 'orderHistory' });
        }

        this.showOrderSuccessAnimation =
            this.$route.query.success === 'true' &&
            this.order.saleOrdStsCode === 'C';
    },
    methods: {
        async cancelOrder() {
            let result = await this.$store.dispatch(
                'cancelOrder',
                this.order.saleOrdTxnNum
            );

            if (result.success) {
                this.$store.commit(
                    'setOrderToOrderList',
                    result.data.salesOrder
                );
            } else {
                this.errors = result.data.errors;
            }
        },
        paymentSelected(paymentOption) {
            this.paymentOption = paymentOption;
        },
        async makePayment(paymentOption) {
            // Create Payment
            const createPaymentResponse = await this.$store.dispatch(
                'createPayment',
                {
                    saleOrdTxnNum: this.order.saleOrdTxnNum,
                    pymtSrvcPrvdId: paymentOption.pymtSrvcPrvdId,
                    pymtMthdId: paymentOption.pymtMthdId
                }
            );

            if (createPaymentResponse.success) {
                if (paymentOption.pymtSrvcPrvdId === 'CASH') {
                    location.reload();
                } else {
                    //Redirect to Payment Gateway
                    let form = createForm(
                        'POST',
                        createPaymentResponse.data.paymentUrl,
                        createPaymentResponse.data.formBody
                    );

                    form.submit();
                }
            } else {
                this.errors = createPaymentResponse.data.errors;
            }
        },
        async enquiryPayment() {
            const createSingelTxnEnquiryResponse = await this.$store.dispatch(
                'createSingleTxnEnquiry',
                {
                    saleOrdTxnNum: this.order.saleOrdTxnNum
                }
            );

            if (createSingelTxnEnquiryResponse.success) {
                let form = createForm(
                    'POST',
                    createSingelTxnEnquiryResponse.data.requestUrl,
                    createSingelTxnEnquiryResponse.data.formBody
                );

                // var querystring = require('querystring');
                // let result = await instance.post(
                //     createSingelTxnEnquiryResponse.data.requestUrl,
                //     querystring.stringify({
                //         ...createSingelTxnEnquiryResponse.data.formBody
                //     })
                // );

                // console.log(result);

                form.submit();
            } else {
                this.errors = createSingelTxnEnquiryResponse.data.errors;
            }
        },
        async mpayTxnRpt() {
            const createMPayTxnRptEnquiryResponse = await this.$store.dispatch(
                'createMPayTxnRptEnquiry'
            );
            if (createMPayTxnRptEnquiryResponse.success) {
                let form = createForm(
                    'POST',
                    createMPayTxnRptEnquiryResponse.data.requestUrl,
                    createMPayTxnRptEnquiryResponse.data.formBody
                );

                // var querystring = require('querystring');
                // let result = await instance.post(
                //     createMPayTxnRptEnquiryResponse.data.requestUrl,
                //     querystring.stringify({
                //         ...createMPayTxnRptEnquiryResponse.data.formBody
                //     })
                // );

                // console.log(result);

                form.submit();
            } else {
                this.errors = createMPayTxnRptEnquiryResponse.data.errors;
            }
        },
        async makeFakePayment() {
            // Create Payment
            const createPaymentResponse = await this.$store.dispatch(
                'createTestPayment',
                {
                    pymtSrvcPrvdId: this.paymentOption.pymtSrvcPrvdId,
                    pymtMthdId: this.paymentOption.pymtMthdId
                }
            );

            if (createPaymentResponse.success) {
                if (
                    this.paymentOption &&
                    this.paymentOption.pymtSrvcPrvdId === 'CASH'
                ) {
                    location.reload();
                } else {
                    //Redirect to Payment Gateway
                    let form = createForm(
                        'POST',
                        createPaymentResponse.data.paymentUrl,
                        createPaymentResponse.data.formBody
                    );

                    form.submit();
                }
            } else {
                this.errors = createPaymentResponse.data.errors;
            }
        },
        orderSuccessAnimationEnded() {
            // Hardcoded
            // Find '{event_id} [token({token_number})]' in sales order remarks
            const promotionEvents = this.$store.state.promotionEvents || [];

            if (!this.order.saleOrdRmkText) {
                return;
            }
            for (let i = 0; i < promotionEvents.length; i++) {
                const eventId = promotionEvents[i].prmtEvntId;
                const saleOrdRmkText = this.order.saleOrdRmkText;
                const regex = new RegExp(`${eventId} [token([0-9]+\\)]`);
                const found = regex.exec(saleOrdRmkText);

                if (found) {
                    const token = parseInt(
                        found[0].slice(`${eventId} [token(`.length, -2)
                    );
                    if (token) {
                        this.luckyDrawSalesOrderModalParams.eventId = eventId;
                        this.luckyDrawSalesOrderModalParams.tokenNum = token;
                        this.showLuckyDrawSalesOrderModal = true;
                        break;
                    }
                }
            }
        }
    }
};
</script>
